import { httpClient, ROOT_URL } from '../App';
import WorldCheckLogo from '../common/images/png/world-check.png'; // if necessary, need to move to azure cloud

export async function fetchFurtherInformation(
  companyCaseId: string | undefined = undefined,
  individualCaseId: string | undefined = undefined,
  setFetchingDetails: (value: boolean) => void,
) {
  try {
    setFetchingDetails(true);
    let caseId = companyCaseId;
    let response = await httpClient.get(`${ROOT_URL}/api/v1/worldCheck/screening/${caseId}`);

    if (!response.data) {
      caseId = individualCaseId;
      response = await httpClient.get(`${ROOT_URL}/api/v1/worldCheck/screening/${caseId}`);
    }

    const { data } = response;
    let results;

    if (data) {
      results = await Promise.allSettled(
        data.map(
          async (item: { referenceId: string; primaryName: string }) =>
            await httpClient
              .get(`${ROOT_URL}/api/v1/worldCheck/${item.referenceId}`)
              .then(res => ({ ...res, primaryName: item.primaryName })),
        ),
      );
    }

    const newWindow = window.open('', '_blank');

    if (newWindow) {
      const contentArray = [
        `
          <html>
          <head>
            <title>Details</title>
            <style>
              body {
                font-family: sans-serif;
                line-height: 1.6;
                color: #2c3e50;
                margin: 20px;
              }
              h1 {
                padding-bottom: 10px;
                border-bottom: 1px solid #ccc;
              }
              .header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
              }
              .header-title {
                font-size: 30px;
                font-weight: bold;
                color: #001eff;
              }
              .header-logo img {
                max-width: 450px;
                height: auto;
              }
            </style>
          </head>
          <body>
            <div class="header">
              <div class="header-title">HIGH RISK STATUS REASONS</div>
              <div class="header-logo">
                <img src="${WorldCheckLogo}" alt="World Check Logo">
              </div>
            </div>
        `,
      ];

      results?.forEach(result => {
        if (result.status === 'fulfilled') {
          contentArray.push(`<h1>${result.value.primaryName ? result.value.primaryName : `NO NAME AVAILABLE...`}</h1>`);
          result.value.data?.forEach((item: { title: string; text: string }) => {
            contentArray.push(`<h3>${item.title ? item.title : 'No title available...'}</h3>`);
            contentArray.push(item.text ? item.text : 'No text available...');
          });
        } else {
          console.error('Error fetching record:', result.reason);
        }
      });

      contentArray.push('</body></html>');
      const content = contentArray.join('');

      newWindow.document.write(content);
      newWindow.document.close();
    } else {
      console.error('Failed to open new window');
    }
  } catch (e) {
    console.error('Error fetching details:', e);
  } finally {
    setFetchingDetails(false);
  }
}
